'use client';

import { useZendesk } from './use-zendesk';

export const Zendesk = () => {
  useZendesk();
  return null;
};
